export enum UsersTypes {
  GET_USERS = '@@users/GET_USERS',
  GET_USER_EMAIL = '@@users/GET_USER_EMAIL',
  GET_USERS_SUCCESS = '@@users/GET_USERS_SUCCESS',
  GET_USERS_FAIL = '@@users/GET_USERS_FAIL',

  GET_USERS_DETAIL = '@@users/GET_USERS_DETAIL',
  GET_USERS_DETAIL_SUCCESS = '@@users/GET_USERS_DETAIL_SUCCESS',
  GET_USERS_DETAIL_FAIL = '@@users//GET_USERS_DETAIL_FAIL',

  ADD_USERS = '@@users/ADD_USERS',
  ADD_USERS_SUCCESS = '@@users/ADD_USERS_SUCCESS',
  ADD_USERS_FAIL = '@@users/ADD_USERS_FAIL',

  DELETE_USERS = '@@users/DELETE_USERS',
  DELETE_USERS_SUCCESS = '@@users/DELETE_USERS_SUCCESS',
  DELETE_USERS_FAIL = '@@users/DELETE_USERS_FAIL',

  UPDATE_USERS = '@@users/UPDATE_USERS',
  UPDATE_USERS_SUCCESS = '@@users/UPDATE_USERS_SUCCESS',
  UPDATE_USERS_FAIL = '@@users/UPDATE_USERS_FAIL',

  PASSWORD_REQUEST_USERS = '@@users/PASSWORD_REQUEST_USERS',
  PASSWORD_REQUEST_USERS_SUCCESS = '@@users/PASSWORD_REQUEST_USERS_SUCCESS',
  PASSWORD_REQUEST_UPDATE_USERS = '@@users/PASSWORD_REQUEST_UPDATE_USERS',
  PASSWORD_REQUEST_UPDATE_USERS_SUCCESS = '@@users/PASSWORD_REQUEST_UPDATE_USERS_SUCCESS',
}
